/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CountryLiveDataFromJSON, CountryLiveDataToJSON } from './CountryLiveData';
import { HourlyDataPointFromJSON, HourlyDataPointToJSON } from './HourlyDataPoint';
/**
 * Check if a given object implements the LiveMetrics interface.
 */
export function instanceOfLiveMetrics(value) {
    if (!('countryLive' in value) || value['countryLive'] === undefined)
        return false;
    if (!('generationsThisHour' in value) || value['generationsThisHour'] === undefined)
        return false;
    if (!('hourUtc' in value) || value['hourUtc'] === undefined)
        return false;
    if (!('hourlySeries24h' in value) || value['hourlySeries24h'] === undefined)
        return false;
    if (!('plausibleRealtimeVisitors' in value) || value['plausibleRealtimeVisitors'] === undefined)
        return false;
    if (!('sessionInitsThisHour' in value) || value['sessionInitsThisHour'] === undefined)
        return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined)
        return false;
    return true;
}
export function LiveMetricsFromJSON(json) {
    return LiveMetricsFromJSONTyped(json, false);
}
export function LiveMetricsFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'countryLive': (json['country_live'].map(CountryLiveDataFromJSON)),
        'generationsThisHour': json['generations_this_hour'],
        'hourUtc': json['hour_utc'],
        'hourlySeries24h': (json['hourly_series_24h'].map(HourlyDataPointFromJSON)),
        'plausibleRealtimeVisitors': json['plausible_realtime_visitors'],
        'sessionInitsThisHour': json['session_inits_this_hour'],
        'updatedAt': json['updated_at'],
    };
}
export function LiveMetricsToJSON(json) {
    return LiveMetricsToJSONTyped(json, false);
}
export function LiveMetricsToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'country_live': (value['countryLive'].map(CountryLiveDataToJSON)),
        'generations_this_hour': value['generationsThisHour'],
        'hour_utc': value['hourUtc'],
        'hourly_series_24h': (value['hourlySeries24h'].map(HourlyDataPointToJSON)),
        'plausible_realtime_visitors': value['plausibleRealtimeVisitors'],
        'session_inits_this_hour': value['sessionInitsThisHour'],
        'updated_at': value['updatedAt'],
    };
}
